import API from '@/api/Page'
import { path, mergeDeepRight } from 'ramda'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('Page')
import { i18n } from '@/i18n'

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
  addon(state, payload) {
    if (!state.item.id) return
    if (payload.state) state.item.metadata.addons.push(payload.addon)
    else state.item.metadata.addons.splice(state.item.metadata.addon.indexOf(payload.addon), 1)
  },
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
  updateSchema({ commit, state }) {
    if (!state.item.id) return
    return API.get({ id: state.item.id }, { query: 'PageSchemaUpdate' }).then(data => {
      commit('set', mergeDeepRight(state.item, data))
    })
  },
  addon({ commit, state }, payload) {
    if (!payload.project && !state.item.id) return
    return API.addon({ project: state.item.id, ...payload }).then(() => {
      commit('addon', payload)
    })
  },
}

const getters = {
  hasRole: state => (role, context) => {
    if (!context) context = state.item
    role = role instanceof Array ? role : [role]
    if (!path(['access', 'roles', 'length'], context)) return false
    return role.some(r => {
      if (r instanceof RegExp) return context.access.roles.some(ro => ro.match(r))
      return context.access.roles.includes(r)
    })
  },
  getDisabledField: state => (field, context) => {
    if (!context) context = state.item
    return path(['metadata', 'disabledFields', field], context)
  },
  getCategory: (state, getters, rootState) => category => {
    let item =
      rootState.enums.PageCategories.find(c => c.id === (category || path(['item', 'theme', 'category'], state))) || {}

    item.label = i18n.tc(item.label, 2)
    sessionStorage.setItem(`page:category`, JSON.stringify(item))
    return item
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
